import { useQuery } from "@tanstack/react-query";

export function useBookings() {
  return useQuery({
    queryKey: ["bookings"],
    queryFn: async () => {
      console.log("Fetching bookings at:", new Date().toISOString());
      try {
        const response = await fetch("/api/bookings/all");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log("Bookings data received:", data);
        return data;
      } catch (error) {
        console.error("Error fetching bookings:", error);
        throw error;
      }
    },
  });
}

export function useBookingsDate(date?: Date) {
  return useQuery({
    queryKey: ["bookings", date?.toISOString().split("T")[0]],
    queryFn: async () => {
      if (!date) return [];

      const dateString = date.toISOString().split("T")[0];
      console.log("Fetching bookings for date:", dateString);

      try {
        const response = await fetch(`/api/bookings?date=${dateString}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch bookings for date ${dateString}`);
        }
        const data = await response.json();
        console.log("Received bookings for date:", dateString, data);
        return data;
      } catch (error) {
        console.error("Error fetching bookings for date:", error);
        throw error;
      }
    },
    enabled: !!date,
  });
}